import { Typography } from '@iheartjane/reefer';

export const AgreementLabel = ({
  label = '',
  required = false,
}: {
  label?: string;
  required?: boolean;
}) => {
  return (
    <Typography>
      {required && (
        <Typography color="error" as="span">
          *
        </Typography>
      )}
      {label}
    </Typography>
  );
};
